var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V256V496H256H496V256V16H256H16V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.5 16H206.5V496H305.5V16Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 305.5V206.5H16V305.5H496Z",
    fill: "#E32D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9476 292.337L110.176 274.169H274.228V237.831H110.176L91.9476 219.662V292.337Z",
    fill: "#F9DD16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/GG.45d51f11d84d5016ab95da02044588af.svg";
export { ForwardRef as ReactComponent };